import { forwardRef } from 'react'
import { EndIcon, StartIcon } from '../Button/styles'
import { LoadingButtonProps } from './props'
import { LoadingAnimation, StyledLoadingButton } from './styles'

const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
    ({ children, disabled, endIcon, loading, startIcon, ...props }, ref) => (
        <StyledLoadingButton
            {...props}
            disabled={disabled || loading}
            loading={loading}
            ref={ref}
        >
            {loading && (
                <LoadingAnimation>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </LoadingAnimation>
            )}
            {startIcon && <StartIcon>{startIcon}</StartIcon>}
            <div>{children}</div>
            {endIcon && <EndIcon>{endIcon}</EndIcon>}
        </StyledLoadingButton>
    )
)

LoadingButton.displayName = 'LoadingButton'

export default LoadingButton

export { StyledLoadingButton }
